// graph tool object - to pass to Canvas

export class GraphProbType {
    graphType: string; displayGrids: boolean; xStart: number; xEnd: number;
    yStart: number; yEnd: number;
    constructor(graphType: string, displayGrids: boolean, xStart: number, xEnd: number, yStart: number, yEnd: number) {
        this.graphType = graphType;
        this.displayGrids = displayGrids;
        this.xStart = xStart;
        this.xEnd = xEnd;
        this.yStart = yStart;
        this.yEnd = yEnd;
    }
}

// graphType const values
export const GT_TYPE_POS = "graphPos";
export const GT_TYPE_POS_NEG = "graph4Quad";
export const GT_TYPE_NUM_LINE = "numLine";

// routine to call will be named
// cvNewGraphProb(GraphProbObj) 
// and passed one parameter of type above GraphProbType


// API DEFINITION for calls to canvas from Angular for Draw Tool Support

// Canvas routines for angular to call for draw tool actions will be the following:
// 
// When the user clicks on the grey bar draw tool icon (pencil box)
// If this is starting the draw tool (switch from math keys to draw tool), then call
//      cvControl(CV_CNTL_START_DRAW_TOOL);
//      cvDrawTool(drawToolObj);  
// The drawToolObj needs to be passed with all of the values last selected by user.  For any value the
// user has not yet selected (in this session), then use default values.  User draw tool selections should be saved during a session
// as much as is practical to do in front-end, but do not need to be saved to web host. 

// When the user clicks the draw tool icon to end draw tool (switching from draw palette tiles to math keys), then call
//      cvControl(CV_CNTL_END_DRAW_TOOL);
// The new CV_CNTL constants are found in canvasSymTypes
// There may be additional conditions that trigger an end to draw tool mode, tbd
//
// Once in draw tool mode, then call cvDrawTool with each user click that represents a change to the values selected
// Note that the user has to then click on canvas to do drawing.  The cvDrawTool call tells canvas what type of drawing to 
// do when the user clicks

// Below is an object class definition, for the object to pass to canvas with draw tool values. 
// This object needs to be filled in with current values for every call to cvDrawTools.  A user can draw
// immediately after clicking the pencil icon by clicking in canvas (which will then use current or default values.)
// They do not have to click to select values in sideboard before each drawing action

export class DrawToolType {
    drawMode: string; toolType: string; lineStartType: string; lineEndType: string; jointType:
        string; shapeType: string; shapeFill: string; lineOpacity: number; regLineSize: number; regColor: string;
    highlightLineSize: number; highlightColor: string; lineStyle: string; highlight: string;
    constructor(drawMode: string, toolType: string, lineStartType: string, lineEndType: string, jointType: string, shapeType: string,
        shapeFill: string, lineOpacity: number, regLineSize: number, regColor: string,
        highlightLineSize: number, highlightColor: string, lineStyle: string, highlight: string) {

        this.drawMode = drawMode;                   // Value based on orange tile "select" (3rd option) vs either of "tool" or "line/color"
        this.toolType = toolType;                   // Value based on which of the 6 grey tile tools are selected currently
        this.lineStartType = lineStartType;         // When toolType == DT_TOOL_LINE or DT_TOOL_MULTI_LINE, set this to 
        // the line starting End Point type
        this.lineEndType = lineEndType;             // When toolType == DT_TOOL_LINE or DT_TOOL_MULTI_LINE, set this to 
        // the line finishing (second) End Point type  (none, dot, arrow, etc)
        this.jointType = jointType;                 // When toolType == DT_TOOL_MULTI_LINE, set to joint type
        this.shapeType = shapeType;                 // When toolType == DT_TOOL_SHAPE, set to shape type           
        this.shapeFill = shapeFill;                 // When toolType == DT_TOOL_SHAPE, set to shape Fill or Outine type 
        this.lineOpacity = lineOpacity;             // Always include - Number value indicating current opacity -
        // Based on user choice of regular, hightlight type 1 or highlight type 2 
        this.regLineSize = regLineSize;             // Always include - Number value of current regular (not highlight) line thickness
        this.regColor = regColor;                   // Always include - CSS color value of current regular (not highlight) line color
        this.highlightLineSize = highlightLineSize; // Always include - Number value of current line thickness (pixel size) 
        this.highlightColor = highlightColor;       // Always include - CSS color value of current highlight line color
        this.lineStyle = lineStyle;
        this.highlight = highlight;
    }
}

// For constants used in draw tool, values will be used in canvas as below, 
// except for values such as line thickness and colors described above the constants

// For the remainder of the constants, canvas will refer to the name of the constants here
// within program logic, and will also save the value of the constants within math json files 
// produced to send to the web host. I have chosen string values representative of what the values mean
// to make the jsonFile format object saved to the web host as more meaningful to look
// at when debugging.  Also, since the order of tools or objects shown in the draw tool sideboard could change 
// in the future, I did not think these constant values should be based on the position
// within html of the draw tool sideboard buttons


// These first two constants tell canvas which of the top orange bar tiles are selected
// Send canvas "DT_DRAW_MODE" if either the tool icon or the line/color icon is selected
// send canvas "DT_EDIT_MODE" if the selection icon is selected
// I didn't define constants for the 3 orange tile icons themselves, since canvas won't reference these,
// but feel free to add them if useful here
// drawMode constants
export const DT_DRAW_MODE = "addNew";
export const DT_DRAW_MODE_2 = "setColorLines";
export const DT_EDIT_MODE = "drawEdit";

export const DT_TOOL_POINT = "point";
export const DT_TOOL_LINE = "line";
export const DT_TOOL_MULTI_LINE = "multiLine";
export const DT_TOOL_FREEHAND = "freehand";
export const DT_TOOL_SHAPE = "shape";
export const DT_TOOL_ERASER = "eraser";

// Constants to define endpoints of lines and multi-lines
export const DT_END_POINT_NONE = "endNone";
export const DT_END_POINT_DOT = "endDot";
export const DT_END_POINT_OPEN_DOT = "endOpenDot";
export const DT_END_POINT_ARROW = "endArrow";
export const DT_END_POINT_ARROW_DOT = "endArrowDot";

// Constants to define multi-line joints
export const DT_MULTI_LINE_JOINT_NONE = "jointNone";
export const DT_MULTI_LINE_JOINT_DOT = "jointDot";
export const DT_MULTI_LINE_CLOSED  = "jointClosed";

// Constants to define shape types
export const DT_SHAPE_CIRCLE = "circle";
export const DT_SHAPE_SQUARE = "square";
export const DT_SHAPE_RECT = "rect";
export const DT_SHAPE_RIGHT_TRIANGLE = "rtria";
export const DT_SHAPE_TRIANGLE = "tria"

// Constants for shape fill or outline
export const DT_SHAPE_SOLID = "solid";
export const DT_SHAPE_OUTLINE = "outline";

// Constants for opacity - regular vs highlight setting
// I am not sure on the best values to use here - I have initially set them to the
// alpha/opacity number values that canvas passes to createjs.  
// Gowtham is you prefer something else that's fine too
// Canvas will need the opacity setting potentially to adjust the color between the two
// highlight values.  For the regular, not highlighted lines I'll just use the color fields
export const DT_LINE_OPACITY_SOLID = 1;
export const DT_LINE_OPACITY_HIGHLIGHT_1 = .3;
export const DT_LINE_OPACITY_HIGHLIGHT_2 = .5;

export const DT_HIGHLIGHT_ON = 'highlight'
export const DT_HIGHLIGHT_OFF = 'noHighlight'

//Constants for line thickness (reg)  
// These need to have number values equal to the actual pixel size the lines should be drawn
// TEMPORARY VALUES - can't find the figma comment with the values

// NOTE to Gowtham  -feel free to change the structures here to arrays or other format if
// that works better for TechJays code.  For these fields canvas won't be comparing these values to 
// any constants defined here - I will instead be using the value passed to give to createjs as the actual
// stroke width of the line to draw
export const DT_LINE_SIZE_1 = 1;
export const DT_LINE_SIZE_2 = 2;
export const DT_LINE_SIZE_3 = 4;
export const DT_LINE_SIZE_4 = 10; //8;
export const DT_LINE_SIZE_5 = 20; //12;
export const DT_LINE_SIZE_6 = 30; //20;

export const DT_HIGHLIGHT_LINE_SIZE_1 = 12; //2;
export const DT_HIGHLIGHT_LINE_SIZE_2 = 18; //4;
export const DT_HIGHLIGHT_LINE_SIZE_3 = 24; //8;
export const DT_HIGHLIGHT_LINE_SIZE_4 = 36; //12;
export const DT_HIGHLIGHT_LINE_SIZE_5 = 48; //20;
export const DT_HIGHLIGHT_LINE_SIZE_6 = 60; //30;

// Constants to define line type
export const DT_LINE_TYPE_SOLID = "solid";
export const DT_LINE_TYPE_DASHED = "dashed";
export const DT_LINE_TYPE_DOTTED = "dotted";

// Constants for draw tool colors - value format as a CSS color definition
// Note to Gowthan - free free to change the format here to whatever might be needed for angular, for example to a static array
// The actual color value should be passed to canvas, so canvas will not refer to the constants definitions
// However, I would like the angular code to use definitions in this file as the source for color definitions, so that
// In the future if I wanted to change  one of the colors shown in the draw tool angular buttons,
// I could do so by changing a value in this file, without having to know anything more about the angular code. 

// The CSS names below are approximations.  Please check with designer and adjust with colors from design
export const DT_COLOR_1 = "black";
export const DT_COLOR_2 = "navy";
export const DT_COLOR_3 = "cyan";
export const DT_COLOR_4 = "green";
export const DT_COLOR_5 = "purple";
export const DT_COLOR_6 = "red";
export const DT_COLOR_7 = "orange";
export const DT_COLOR_8 = "yellow";
export const DT_COLOR_9 = "rgb(64,64,64)";
export const DT_COLOR_10 = "gray";
export const DT_COLOR_11 = "white"
export const DT_COLOR_12 = "black";   // placeholder value  - when a custom color is chosen, then instead send
// canvas the CSS value of color chosen

// colors used as highlights  - NEEDS changing to actual values - please get values from designer
export const DT_COLOR_13 = "pink";
export const DT_COLOR_14 = "orange";
export const DT_COLOR_15 = "yellow";
export const DT_COLOR_16 = "#98FB98"; //green";
export const DT_COLOR_17 = "#99D9F1";  //"blue";
export const DT_COLOR_18 = "tan";

